import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import classNames from 'classnames/bind';
import React, { forwardRef, useCallback } from 'react';
import InputArea from './InputArea.js';
import { INPUT_SHAPE } from '../../constants/input.js';
import { useInputFocus } from '../../hooks/useInputFocus.js';
import { getOnChange, getOnKeyDown, getOnBeforeKeyDownNumberInput, addUnitOnValue } from '../../utils/input.js';
import { getNumberString } from '../../utils/string.js';
import styles from './InputLineAmount.module.scss.js';

var _excluded = ["value", "readOnly", "disabled", "onChange", "onKeyDown", "onFocus", "onBlur", "onSelect", "maxDecimalDigits", "unit", "hasError", "errorMessage", "guideMessage", "onClickDeleteButton"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
/**
 * Line 형태의 금액 입력 Input
 * - 숫자만 입력할 수 있습니다.
 * - 값이 존재할 때 끝에 단위 텍스트를 표시합니다. (기본값: 원)
 * - maxDecimalDigits 값으로 최대로 입력 가능한 소수점 자리수를 설정할 수 있습니다. (기본값: 0)
 * - maxDecimalDigits 값에 따라 inputMode 어트리뷰트를 설정합니다.
 *     - `maxDecimalDigits === 0` ➝ `numeric`
 *     - `maxDecimalDigits > 0` ➝ `decimal`
 */
var InputLineAmount = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    readOnly = _ref.readOnly,
    disabled = _ref.disabled,
    _onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onSelect = _ref.onSelect,
    _ref$maxDecimalDigits = _ref.maxDecimalDigits,
    _maxDecimalDigits = _ref$maxDecimalDigits === void 0 ? 0 : _ref$maxDecimalDigits,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? '원' : _ref$unit,
    hasError = _ref.hasError,
    errorMessage = _ref.errorMessage,
    guideMessage = _ref.guideMessage,
    onClickDeleteButton = _ref.onClickDeleteButton,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useInputFocus = useInputFocus({
      onFocus: onFocus,
      onBlur: onBlur
    }),
    isFocused = _useInputFocus.isFocused,
    handleFocus = _useInputFocus.handleFocus,
    handleBlur = _useInputFocus.handleBlur;
  var maxDecimalDigits = Math.max(_maxDecimalDigits, 0);
  var handleSelect = useCallback(function (e) {
    var _inputElement$selecti, _inputElement$selecti2;
    var inputElement = e.currentTarget;
    var selectionStart = (_inputElement$selecti = inputElement.selectionStart) !== null && _inputElement$selecti !== void 0 ? _inputElement$selecti : 0;
    var selectionEnd = (_inputElement$selecti2 = inputElement.selectionEnd) !== null && _inputElement$selecti2 !== void 0 ? _inputElement$selecti2 : 0;
    var maxCursorPos = inputElement.value.replace(unit, '').length;
    if (selectionStart > maxCursorPos || selectionEnd > maxCursorPos) {
      inputElement.setSelectionRange(Math.min(selectionStart, maxCursorPos), Math.min(selectionEnd, maxCursorPos));
    }
    onSelect === null || onSelect === void 0 || onSelect(e);
  }, [onSelect, unit]);
  var format = function format(v) {
    return addUnitOnValue(getNumberString(v, {
      addComma: true,
      maxDecimalDigits: maxDecimalDigits
    }), unit);
  };
  var handleChange = getOnChange({
    format: format,
    fixCursor: function fixCursor(v) {
      var _v$split$shift;
      return (_v$split$shift = v.split(unit).shift()) !== null && _v$split$shift !== void 0 ? _v$split$shift : v;
    },
    onChange: function onChange(e) {
      _onChange === null || _onChange === void 0 || _onChange({
        value: getNumberString(e.target.value, {
          addComma: false,
          maxDecimalDigits: maxDecimalDigits
        }),
        formattedValue: e.target.value
      }, e);
    }
  });
  var handleKeyDown = getOnKeyDown({
    onBeforeKeyDown: getOnBeforeKeyDownNumberInput({
      unitOnValue: unit,
      maxDecimalDigits: maxDecimalDigits
    }),
    onKeyDown: onKeyDown
  });
  var isEditable = !readOnly && !disabled;
  var isShowDeleteButton = isEditable && !!value;
  return /*#__PURE__*/React.createElement(InputArea, {
    type: INPUT_SHAPE.LINE,
    hasError: hasError,
    isFocused: isFocused,
    disabled: disabled,
    errorMessage: errorMessage,
    guideMessage: guideMessage,
    value: value
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('input-value')
  }, /*#__PURE__*/React.createElement("input", _objectSpread({
    ref: ref,
    className: cx('value'),
    type: "text",
    inputMode: maxDecimalDigits ? 'decimal' : 'numeric',
    value: format(value),
    readOnly: readOnly,
    disabled: disabled,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onSelect: handleSelect
  }, restProps))), /*#__PURE__*/React.createElement(InputArea.DeleteButton, {
    isShow: isShowDeleteButton,
    onClick: onClickDeleteButton
  }));
});

export { InputLineAmount as default };
